import React from 'react';
import { compose } from 'redux';

import Parts from 'containers/Parts/';
import PartsForm from 'containers/Parts/PartsForm';
import PartsResult from 'containers/Parts/PartsResult';
import Map from 'components/Map';
import PromoPaymentBanner from 'components/PromoPaymentBanner'


import Container from 'components/Container';
import FacetRev from 'components/FacetRev';
import Hero from './Hero';
import Text from 'components/Text';
import { H1, Gapper, Text2 } from 'components/Ui'
import PodborInit from 'components/PodborInit'

import Podbor from 'components/Podbor'
import Banners from 'components/Banners'

const HomeDealer = function (props) {
  const {
    pageData, addToCart, products, currentDomain, images, addToPodbor
  } = props;
  const { status, number, podbor } = pageData;

  return (
    <>
      <Banners />

      <div className="white">
        <Container>
          <Gapper gap={20}>
            <H1 center style={{textAlign: 'center'}}>
              Оригинальные детали ŠKODA
            </H1>
            <Text2 center>
              <p>Доверьте подбор оригинальных деталей для своего автомобиля официальному дилеру ŠKODA.</p>
              <p>Чтобы добавить необходимую деталь, введите ее название в поле поиска, укажите свои контактные данные и желаемого дилера. Специалисты выбранного Вами официального дилера ŠKODA свяжутся с Вами и помогут подобрать именно то, что нужно Вашему автомобилю.</p>
            </Text2>     
            <PartsForm pageData={pageData} addToPodbor={addToPodbor} dealer/>
          </Gapper>
        </Container>
        <Container>
          {podbor === 'podbor' && (<Podbor/>)}
          {podbor === 'prepodbor' && (<PodborInit />)}
          <div className="panel panel_np">
            {!podbor && (() => {
              switch (status) {
                case 'initial':
                  return <Map />
                case 'loading':
                  return (
                    <div className="loading" style={{ padding: 25 }}>
                      Загрузка
                    </div>
                  );
                case 'finished':
                  return <PartsResult strict number={number} product={products[number]} addItemToCart={addToCart} {...props} />;
                default:
                  return null;
              }
            })()}
          </div>
          <PromoPaymentBanner />
        </Container>
        <FacetRev color="#fff" abs="true" />
      </div>
    </>
  );
};

// <div className="parts">

// </div>

const withParts = Parts();

export default compose(
  withParts,
)(HomeDealer);
